<template>
  <v-container>
  <v-card color="oug" class="pa-1 mx-auto text-center justify-center"
      max-width="600"
      elevation="24">
    <v-card-title class="text-h6 white--text">Courses</v-card-title>
    <v-card-subtitle class="white--text" align="start">
        This section is the courses linked to accreditations. Please have your OwnUrGoal login details ready when completing these courses.
      </v-card-subtitle>
    <div>
      <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="oug"
        dark
      >
        <v-card-text>
          Loading Courses. Please Stand By
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
    <v-expansion-panels focusable>
      <v-expansion-panel v-for="(document, i) in Documents" :key="i">
        <v-expansion-panel-header>{{
          document.category
        }}
        <v-spacer></v-spacer>
        <!-- <v-btn>Add Job</v-btn> -->
        </v-expansion-panel-header>
        <p></p>
        <v-expansion-panel-content
          class="justify-start"
          v-for="(item, i) in document.items"
          :key="i"
        >
          <v-row no-gutters>
            <p @click="openDocument(item.url)">{{ item.title }}</p>
          </v-row>
          <v-divider></v-divider>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
  </v-container>
</template>

<script>
// import Documents from "../data/Documents";
// import results from "../data/result";
import axios from "axios";

export default {
  data() {
    return {
      Documents: [],
      result: []
    };
  },
  created() {
    // this.oldLoadDocuments();
    this.loadDocuments(document);
    this.filterCourseDocuments();
  },

  methods: {
    filterCourseDocuments(){
      console.log("This Document", this.Documents)
    },
    loadDocuments() {
      // Load Documents from the Referees App
      const payload = {
        Team_id: 423,
        Contact_id: 144,
      };
      this.loadingDialog = true;
      const baseURL = "https://server.ownurgoal.net.au/gen/GetDocuments";
      axios.post(baseURL, payload).then((response) => {
        // Create axios call to get result
        const results = response.data.result;
        console.log("results2", results)
        // With the result (array of documents)
        // let result = [];
        // Do for loop to loop through each item in Results array
        // console.log("1")
        results
          .forEach((result) => {
            // console.log("2")
            // Firstly check category name in documents array (for all records)
            if (result.type == "COURSE") {
            let documentIndex = this.Documents.findIndex((element) => {
              return element.category == result.Category_Name;
            });
            if (documentIndex == -1) {
              // Option A: No category found
              this.Documents.push({
                category: result.Category_Name,
                items: [],
              });
              let currentDoc = this.Documents.length - 1;
              this.Documents[currentDoc].items.push({
                title: result.Title,
                url: result.url,
              });
              this.loadingDialog = false;
            } else {
              // Option B: Category found = n in the Documents array
              this.Documents[documentIndex].items.push({
                title: result.Title,
                url: result.url,
              });
              // End of For Loop
              // this.saveDexie({
              //   // ele: element,
              //   desc: "documents",
              // });
            }
            }
          })
          // .catch((error) => {
          //   console.log(error);
          //   this.error = "Error trying to load documents please try again";
          // });
      });
    },

    // oldLoadDocuments(){
    //   console.log("results1", results)
    // // Create axios call to get result
    // // With the result (array of documents)
    // // let results = [];
    // // Do for loop to loop through each item in Results array
    // results.forEach(result => {
    //   // Firstly check category name in documents array (for all records)
    //       let documentIndex =  this.Documents.findIndex((element) => {
    //         return element.category == result.Category_Name
    //       })
    //       if (documentIndex == -1) {
    //         // Option A: No category found
    //               this.Documents.push({"category": result.Category_Name, "items": []})
    //               let currentDoc = (this.Documents.length - 1);
    //               this.Documents[currentDoc].items.push({"title": result.Title, "url": result.url})
    //       }
    //       else
    //       {
    //           // Option B: Category found = n in the Documents array
    //               this.Documents[documentIndex].items.push({"title": result.Title, "url": result.url})
    //       }

    // // End of For Loop
    // });
    // },
    openDocument(url) {
      let file = url;
      window.open(file, "_system");
    },
  },
};
</script>